import type { ISerialize } from '@/objects/ISerialize';
import type { DuplicateMergeSource } from './../enums/DuplicateMergeSource';
import { formatDateIso } from '@/utilities/dateutils';

export class DuplicateSearchResult implements ISerialize {
    public ID: number;

    public Count: number;

    public Created: Date;

    public Source: DuplicateMergeSource;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { ID?: number; Count?: number; Created?: Date; Source?: DuplicateMergeSource }) {
        this.ID = values.ID ?? 0;

        this.Count = values.Count ?? 0;

        this.Created = values.Created ?? new Date('1970-01-01T00:00:00.000');

        this.Source = values.Source ?? 'VippsParticipants';
    }

    public serialize(): string {
        return (
            '{' +
            `"ID": ${JSON.stringify(this.ID)}` +
            ',' +
            `"Count": ${JSON.stringify(this.Count)}` +
            ',' +
            `"Created": ${'"' + formatDateIso(this.Created) + '"'}` +
            ',' +
            `"Source": ${this.Source == 'VippsParticipants' ? 1 : 1}` +
            '}'
        );
    }

    /**
     * Creates an instance of DuplicateSearchResult from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        ID?: number;
        Count?: number;
        Created?: Date;
        Source?: DuplicateMergeSource;
    }): DuplicateSearchResult {
        return new DuplicateSearchResult(values);
    }

    public static _FromServerJson(json: any): DuplicateSearchResult {
        return new DuplicateSearchResult({
            ID: json.ID,
            Count: json.Count,
            Created: json.Created instanceof Date ? json.Created : new Date(json.Created),
            Source: json.Source == 1 ? 'VippsParticipants' : 'VippsParticipants',
        });
    }

    /**
     * Creates an instance of DuplicateSearchResult from another instance of DuplicateSearchResult.
     * @param other The DuplicateSearchResult you want to clone
     * @returns A cloned DuplicateSearchResult
     */
    public static FromOther(other: DuplicateSearchResult): DuplicateSearchResult {
        return DuplicateSearchResult._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return DuplicateSearchResult.FromOther(this);
    }

    static NAME_OF_CLASS = 'DuplicateSearchResult';
}
